import firebase from "firebase/app";
import "firebase/analytics";
import { isNullOrUndefined } from "util";
import * as Const from './const';
import * as Cred from './creds';
import { GoogleSpreadsheet } from 'google-spreadsheet';

var hoverCharts = {

}

export const logButtonClick = (button_event, properties) => {
    let newProperties = {};
    if(!isNullOrUndefined(properties)){
        newProperties = properties;
    }
    if(!isNullOrUndefined(button_event) && button_event.trim().length>0)
        firebase.analytics().logEvent(button_event, newProperties);
}

export const linkClick = (url, properties) => {
    let newProperties = {};
    if(!isNullOrUndefined(properties)){
        newProperties = properties;
    }
    newProperties['url'] = url;
    // console.log(url, properties)
    firebase.analytics().logEvent('open_source_link', properties);
} 

export const summaryOpen = (url, properties) => {
    let newProperties = {};
    if(!isNullOrUndefined(properties)){
        newProperties = properties;
    }
    newProperties['url'] = url;
    // console.log(url, properties)
    firebase.analytics().logEvent('open_source_summary_open', properties);
}

export const generalDataSourceClick = (url, context, subContexts) => {
    let newProperties = {
        'main_context': 'general_data'
    };
    if(!isNullOrUndefined(context)){
        newProperties['sub_context'] = context;
    }

    for(let i=0; !isNullOrUndefined(subContexts) && i<subContexts.length; i++){
        let key = 'sub_context_'+String(i+2);
        let val = subContexts[i];
        newProperties[key] = val; 
    }

    linkClick(url,newProperties);
} 

export const hoverOverDiv = (divName, hoverIn) => {

    try{
        if(hoverIn){
            //Hovered inside the div

            let ts = Date.now();
            if(!isNullOrUndefined(divName))
                hoverCharts[divName] = ts;
        }
        else{
            //HoveredOut

            let ts = Date.now();
            if(!isNullOrUndefined(divName) && !isNullOrUndefined(hoverCharts[divName])){
                let oldTime = "" ;
                if(!isNaN(Date(hoverCharts[divName])) && !isNullOrUndefined(Date(hoverCharts[divName])))
                    oldTime = Date(hoverCharts[divName]).toString();
                let diffTs = ts - hoverCharts[divName];
                let diffSecs = diffTs/1000;
                let diffMin = diffSecs/60;

                //No need of it now
                delete hoverCharts[divName];

                //have minutes and seconds
                let properties = {
                    hover_object: divName,
                    total_min: diffMin,
                    total_sec: diffSecs,
                    total_ms: diffTs,
                    dateTime: oldTime
                }
                // console.log(properties)
                if(diffSecs>=Const.analyticsHoverTime_secs)
                    firebase.analytics().logEvent('hover', properties);    
            }
        }
    }
    catch(error){
        firebase.analytics().logEvent('hover', {errorMsg: String(error)});
    }
}


export const logSearchInExcel = async(feedback_row) => {


    if(isNullOrUndefined(feedback_row) || isNullOrUndefined(feedback_row.userId) || isNullOrUndefined(feedback_row.company)
    || isNullOrUndefined(feedback_row.date))
        return;
    try{
    let docId = Cred.feedbackGoogleSheetCred.sheetId;

    let doc = new GoogleSpreadsheet(docId);
    // console.log(doc);
   
    if(isNullOrUndefined(doc))
        return;
    await doc.useServiceAccountAuth({
        "private_key": Cred.feedbackGoogleSheetCred.private_key,
        "client_email": Cred.feedbackGoogleSheetCred.client_email,
        });
    
    let feedback_sheet = "Search_stats";

//    /*
    await doc.loadInfo();
    const sheet = doc.sheetsByTitle[feedback_sheet]; // or use doc.sheetsById[id] or doc.sheetsByTitle[title]
    // console.log(sheet.title);
    // console.log(feedback_row);
    
    
    await sheet.addRow(feedback_row);

 /*   
 await sheet.addRow({ 
        email: 'flowpro2021@gmail.com', 
        description: 'I need these specific insights right now.', 
        date: Date.now().toString(),
        company: company 
    });
//   */ 
    }catch(e){

    }
}


export const logIconDownloadInExcel = async(feedback_row) => {


    if(isNullOrUndefined(feedback_row) || isNullOrUndefined(feedback_row.userId) || isNullOrUndefined(feedback_row.icon_link)
    || isNullOrUndefined(feedback_row.search_term) || isNullOrUndefined(feedback_row.date))
        return;
    try{
    let docId = Cred.feedbackGoogleSheetCred.sheetId;

    let doc = new GoogleSpreadsheet(docId);
    // console.log(doc);
   
    if(isNullOrUndefined(doc))
        return;
    await doc.useServiceAccountAuth({
        "private_key": Cred.feedbackGoogleSheetCred.private_key,
        "client_email": Cred.feedbackGoogleSheetCred.client_email,
        });


    let feedback_sheet = "Icon download";


//    /*
    await doc.loadInfo();
    const sheet = doc.sheetsByTitle[feedback_sheet]; // or use doc.sheetsById[id] or doc.sheetsByTitle[title]
    // console.log(sheet.title);
    // console.log(feedback_row);
    // console.log(sheet);
    
    await sheet.addRow(feedback_row);

 /*   
 await sheet.addRow({ 
        email: 'flowpro2021@gmail.com', 
        description: 'I need these specific insights right now.', 
        date: Date.now().toString(),
        company: company 
    });
//   */ 
    }catch(e){
        console.log(e)
    }
}